// Local seed data for File Reconciliation demo
// This data is used when the database tables haven't been populated yet

export const mockRules = [
  {
    rule_id: 1, rule_code: 'row_count_match', rule_name: 'Row Count Match',
    description: 'Verify the number of data rows matches expected count from source system or control file',
    rule_type: 'row_count', rule_category: 'general', severity: 'error', is_active: true,
    ruleset_count: 3,
    parameters_json: JSON.stringify({
      schema: 'etl_staging',
      table: 'etl_outbound.member_import_file_data',
      date_filter: 'created_at >= CURRENT_DATE - 1',
      expected_schema: 'etl_core',
      expected_table: 'ref_consumer',
      source_count_sql: 'SELECT COUNT(*) FROM {{schema}}.{{table}} WHERE {{date_filter}}',
      expected_count_sql: 'SELECT COUNT(*) FROM {{expected_schema}}.{{expected_table}} WHERE {{date_filter}}',
    }, null, 2),
    sql_template: "SELECT ({{source_count_sql}}) as actual_value, ({{expected_count_sql}}) as expected_value, CASE WHEN ({{source_count_sql}}) = ({{expected_count_sql}}) THEN 'pass' ELSE 'fail' END as status",
    created_by: 'system', created_at: '2026-04-01T00:00:00Z',
  },
  {
    rule_id: 2, rule_code: 'required_fields_present', rule_name: 'Required Fields Present',
    description: 'Check that all required columns have no NULL values for the given date range',
    rule_type: 'field_validation', rule_category: 'general', severity: 'error', is_active: true,
    ruleset_count: 2,
    parameters_json: JSON.stringify({
      field: 'member_id',
      schema: 'etl_staging',
      table: 'etl_outbound.member_import_file_data',
      date_filter: 'created_at >= CURRENT_DATE - 1',
    }, null, 2),
    sql_template: "SELECT '{{field}}' as field_name, COUNT(*) as null_count FROM {{schema}}.{{table}} WHERE {{field}} IS NULL AND {{date_filter}}",
    created_by: 'system', created_at: '2026-04-01T00:00:00Z',
  },
  {
    rule_id: 3, rule_code: 'amount_balance_check', rule_name: 'Amount Balance Check',
    description: 'Verify sum of amounts matches control total from source or trailer record',
    rule_type: 'balance_check', rule_category: 'outbound', severity: 'error', is_active: true,
    ruleset_count: 1,
    parameters_json: JSON.stringify({
      amount_column: 'load_amount',
      schema: 'etl_core',
      table: 'card_value_loads',
      date_filter: 'load_date = CURRENT_DATE',
      expected_total_sql: 'SELECT SUM(approved_amount) FROM etl_core.prefunding_approved WHERE approval_date = CURRENT_DATE',
    }, null, 2),
    sql_template: "SELECT SUM({{amount_column}})::DECIMAL(18,2) as actual_value, ({{expected_total_sql}})::DECIMAL(18,2) as expected_value, CASE WHEN SUM({{amount_column}}) = ({{expected_total_sql}}) THEN 'pass' ELSE 'fail' END as status FROM {{schema}}.{{table}} WHERE {{date_filter}}",
    created_by: 'system', created_at: '2026-04-01T00:00:00Z',
  },
  {
    rule_id: 4, rule_code: 'duplicate_check', rule_name: 'Duplicate Record Check',
    description: 'Identify duplicate records based on specified key columns',
    rule_type: 'field_validation', rule_category: 'general', severity: 'warning', is_active: true,
    ruleset_count: 2,
    parameters_json: JSON.stringify({
      key_columns: 'member_id',
      schema: 'etl_staging',
      table: 'etl_outbound.member_import_file_data',
      date_filter: 'created_at >= CURRENT_DATE - 1',
    }, null, 2),
    sql_template: 'SELECT {{key_columns}}, COUNT(*) as dup_count FROM {{schema}}.{{table}} WHERE {{date_filter}} GROUP BY {{key_columns}} HAVING COUNT(*) > 1 LIMIT 100',
    created_by: 'system', created_at: '2026-04-01T00:00:00Z',
  },
  {
    rule_id: 5, rule_code: 'completeness_check', rule_name: 'Completeness Check',
    description: 'Verify all expected records from source are present in target table',
    rule_type: 'completeness', rule_category: 'inbound', severity: 'error', is_active: true,
    ruleset_count: 1,
    parameters_json: JSON.stringify({
      source_schema: 'etl_staging',
      source_table: 'etl_outbound.member_import_file_data',
      target_schema: 'etl_core',
      target_table: 'ref_consumer',
      join_key: 'member_id',
      date_filter: 's.created_at >= CURRENT_DATE - 1',
    }, null, 2),
    sql_template: 'SELECT COUNT(*) as missing_count FROM {{source_schema}}.{{source_table}} s LEFT JOIN {{target_schema}}.{{target_table}} t ON s.{{join_key}} = t.{{join_key}} WHERE t.{{join_key}} IS NULL AND {{date_filter}}',
    created_by: 'system', created_at: '2026-04-01T00:00:00Z',
  },
  {
    rule_id: 6, rule_code: 'cross_reference_check', rule_name: 'Cross Reference Check',
    description: 'Verify referential integrity between two tables based on key columns',
    rule_type: 'cross_reference', rule_category: 'general', severity: 'error', is_active: true,
    ruleset_count: 1,
    parameters_json: JSON.stringify({
      source_schema: 'task',
      source_table: 'consumer_task',
      source_key: 'consumer_code',
      target_schema: 'huser',
      target_table: 'consumer',
      target_key: 'consumer_code',
      date_filter: 's.task_start_ts >= CURRENT_DATE - 1',
    }, null, 2),
    sql_template: "SELECT COUNT(*) as orphan_count FROM {{source_schema}}.{{source_table}} s LEFT JOIN {{target_schema}}.{{target_table}} t ON s.{{source_key}} = t.{{target_key}} WHERE t.{{target_key}} IS NULL AND {{date_filter}}",
    created_by: 'system', created_at: '2026-04-01T00:00:00Z',
  },
  {
    rule_id: 7, rule_code: 'file_freshness_check', rule_name: 'File Freshness Check',
    description: 'Verify file data was loaded within expected timeframe',
    rule_type: 'completeness', rule_category: 'inbound', severity: 'warning', is_active: true,
    ruleset_count: 2,
    parameters_json: JSON.stringify({
      schema: 'etl_staging',
      table: 'etl_outbound.member_import_file_data',
      timestamp_column: 'created_at',
      max_age_hours: 24,
    }, null, 2),
    sql_template: "SELECT DATEDIFF(hour, MAX({{timestamp_column}}), GETDATE()) as hours_since_load, {{max_age_hours}} as max_allowed_hours, CASE WHEN DATEDIFF(hour, MAX({{timestamp_column}}), GETDATE()) <= {{max_age_hours}} THEN 'pass' ELSE 'fail' END as status FROM {{schema}}.{{table}}",
    created_by: 'system', created_at: '2026-04-01T00:00:00Z',
  },
  {
    rule_id: 8, rule_code: 'value_range_check', rule_name: 'Value Range Check',
    description: 'Verify numeric values fall within expected min/max range',
    rule_type: 'field_validation', rule_category: 'general', severity: 'warning', is_active: true,
    ruleset_count: 1,
    parameters_json: JSON.stringify({
      schema: 'etl_core',
      table: 'card_value_loads',
      column: 'load_amount',
      min_value: 0,
      max_value: 10000,
      date_filter: 'load_date >= CURRENT_DATE - 7',
    }, null, 2),
    sql_template: 'SELECT COUNT(*) as out_of_range_count FROM {{schema}}.{{table}} WHERE ({{column}} < {{min_value}} OR {{column}} > {{max_value}}) AND {{date_filter}}',
    created_by: 'system', created_at: '2026-04-01T00:00:00Z',
  },
];

export const mockRulesets = [
  {
    ruleset_id: 1, ruleset_code: 'eligibility_inbound_v1', ruleset_name: 'Eligibility Inbound Validation',
    description: 'Standard validation for all client eligibility files - checks row counts, required fields, duplicates, and freshness',
    is_active: true, rule_count: 4,
    created_by: 'raajeshb@gmail.com', created_at: '2026-04-01T00:00:00Z',
  },
  {
    ruleset_id: 2, ruleset_code: 'task_completion_inbound_v1', ruleset_name: 'Task Completion Inbound Validation',
    description: 'Validates task completion files from KP and HAP - cross-references consumer codes and checks completeness',
    is_active: true, rule_count: 3,
    created_by: 'raajeshb@gmail.com', created_at: '2026-04-01T00:00:00Z',
  },
  {
    ruleset_id: 3, ruleset_code: 'fis_outbound_v1', ruleset_name: 'FIS Outbound Validation',
    description: 'Validates outbound files to FIS - balance checks, row counts, and value range validation',
    is_active: true, rule_count: 3,
    created_by: 'raajeshb@gmail.com', created_at: '2026-04-01T00:00:00Z',
  },
  {
    ruleset_id: 4, ruleset_code: 'card_ship_inbound_v1', ruleset_name: 'Card Ship Inbound Validation',
    description: 'Validates card shipping files from AB Corp - checks completeness and cross-references card orders',
    is_active: true, rule_count: 2,
    created_by: 'raajeshb@gmail.com', created_at: '2026-04-01T00:00:00Z',
  },
];

export const mockRulesetDetail = {
  1: [
    { rule_id: 1, rule_code: 'row_count_match', rule_name: 'Row Count Match', rule_type: 'row_count', severity: 'error', is_active: true, sort_order: 0, is_required: true, override_params: '' },
    { rule_id: 2, rule_code: 'required_fields_present', rule_name: 'Required Fields Present', rule_type: 'field_validation', severity: 'error', is_active: true, sort_order: 1, is_required: true, override_params: '{"fields":["member_id","first_name","last_name","date_of_birth"]}' },
    { rule_id: 4, rule_code: 'duplicate_check', rule_name: 'Duplicate Record Check', rule_type: 'field_validation', severity: 'warning', is_active: true, sort_order: 2, is_required: false, override_params: '{"key_columns":"member_id"}' },
    { rule_id: 7, rule_code: 'file_freshness_check', rule_name: 'File Freshness Check', rule_type: 'completeness', severity: 'warning', is_active: true, sort_order: 3, is_required: false, override_params: '{"max_age_hours":48}' },
  ],
  2: [
    { rule_id: 1, rule_code: 'row_count_match', rule_name: 'Row Count Match', rule_type: 'row_count', severity: 'error', is_active: true, sort_order: 0, is_required: true, override_params: '' },
    { rule_id: 6, rule_code: 'cross_reference_check', rule_name: 'Cross Reference Check', rule_type: 'cross_reference', severity: 'error', is_active: true, sort_order: 1, is_required: true, override_params: '' },
    { rule_id: 5, rule_code: 'completeness_check', rule_name: 'Completeness Check', rule_type: 'completeness', severity: 'error', is_active: true, sort_order: 2, is_required: true, override_params: '' },
  ],
  3: [
    { rule_id: 1, rule_code: 'row_count_match', rule_name: 'Row Count Match', rule_type: 'row_count', severity: 'error', is_active: true, sort_order: 0, is_required: true, override_params: '' },
    { rule_id: 3, rule_code: 'amount_balance_check', rule_name: 'Amount Balance Check', rule_type: 'balance_check', severity: 'error', is_active: true, sort_order: 1, is_required: true, override_params: '' },
    { rule_id: 8, rule_code: 'value_range_check', rule_name: 'Value Range Check', rule_type: 'field_validation', severity: 'warning', is_active: true, sort_order: 2, is_required: false, override_params: '{"min_value":0,"max_value":5000}' },
  ],
  4: [
    { rule_id: 5, rule_code: 'completeness_check', rule_name: 'Completeness Check', rule_type: 'completeness', severity: 'error', is_active: true, sort_order: 0, is_required: true, override_params: '' },
    { rule_id: 7, rule_code: 'file_freshness_check', rule_name: 'File Freshness Check', rule_type: 'completeness', severity: 'warning', is_active: true, sort_order: 1, is_required: false, override_params: '{"max_age_hours":72}' },
  ],
};

export const mockProcesses = [
  {
    process_id: 1, process_code: 'kp_eligibility_inbound', process_name: 'KP Eligibility File',
    description: 'Daily eligibility file from Kaiser Permanente with member enrollment data',
    direction: 'inbound', partner_type: 'client', partner_name: 'Kaiser Permanente',
    file_type: 'eligibility', source_schema: 'etl_staging', source_table: 'etl_outbound.member_import_file_data',
    expected_schedule: 'daily', is_active: true, ruleset_count: 1,
  },
  {
    process_id: 2, process_code: 'hap_eligibility_inbound', process_name: 'HAP Eligibility File',
    description: 'Weekly eligibility file from Health Alliance Plan',
    direction: 'inbound', partner_type: 'client', partner_name: 'HAP',
    file_type: 'eligibility', source_schema: 'etl_staging', source_table: 'etl_outbound.member_import_file_data',
    expected_schedule: 'weekly', is_active: true, ruleset_count: 1,
  },
  {
    process_id: 3, process_code: 'kp_task_completion_inbound', process_name: 'KP Task Completion File',
    description: 'Task completion data from Kaiser Permanente reporting completed health activities',
    direction: 'inbound', partner_type: 'client', partner_name: 'Kaiser Permanente',
    file_type: 'task_completion', source_schema: 'task', source_table: 'consumer_task',
    expected_schedule: 'daily', is_active: true, ruleset_count: 1,
  },
  {
    process_id: 4, process_code: 'hap_task_completion_inbound', process_name: 'HAP Task Completion File',
    description: 'Task completion data from HAP',
    direction: 'inbound', partner_type: 'client', partner_name: 'HAP',
    file_type: 'task_completion', source_schema: 'task', source_table: 'consumer_task',
    expected_schedule: 'weekly', is_active: true, ruleset_count: 1,
  },
  {
    process_id: 5, process_code: 'fis_card_order_outbound', process_name: 'FIS Card Order File',
    description: 'Card order file sent to FIS for new card issuance (Card 30 format)',
    direction: 'outbound', partner_type: 'vendor', partner_name: 'FIS',
    file_type: 'card_order', source_schema: 'fis', source_table: 'consumer_account',
    expected_schedule: 'daily', is_active: true, ruleset_count: 1,
  },
  {
    process_id: 6, process_code: 'fis_value_load_outbound', process_name: 'FIS Value Load File',
    description: 'Value load file sent to FIS for card funding after prefunding approval',
    direction: 'outbound', partner_type: 'vendor', partner_name: 'FIS',
    file_type: 'value_load', source_schema: 'etl_core', source_table: 'card_value_loads',
    expected_schedule: 'daily', is_active: true, ruleset_count: 1,
  },
  {
    process_id: 7, process_code: 'abcorp_card_ship_inbound', process_name: 'AB Corp Card Ship File',
    description: 'Card shipping confirmation file from AB Corp with tracking numbers and delivery status',
    direction: 'inbound', partner_type: 'partner', partner_name: 'AB Corp',
    file_type: 'card_ship', source_schema: 'ab_corp', source_table: 'workorder_shipping_events',
    expected_schedule: 'daily', is_active: true, ruleset_count: 1,
  },
];

export const mockExecutions = [
  {
    run_id: 'a1b2c3d4e5f60001', process_id: 1, process_name: 'KP Eligibility File',
    partner_name: 'Kaiser Permanente', file_type: 'eligibility', direction: 'inbound',
    started_at: '2026-03-31T08:15:00Z', completed_at: '2026-03-31T08:15:12Z',
    total_rules: 4, passed: 4, failed: 0, warnings: 0, errors: 0, skipped: 0,
    overall_status: 'PASSED', executed_by: 'raajeshb@gmail.com',
  },
  {
    run_id: 'a1b2c3d4e5f60002', process_id: 5, process_name: 'FIS Card Order File',
    partner_name: 'FIS', file_type: 'card_order', direction: 'outbound',
    started_at: '2026-03-31T09:30:00Z', completed_at: '2026-03-31T09:30:08Z',
    total_rules: 3, passed: 2, failed: 1, warnings: 0, errors: 0, skipped: 0,
    overall_status: 'FAILED', executed_by: 'raajeshb@gmail.com',
  },
  {
    run_id: 'a1b2c3d4e5f60003', process_id: 6, process_name: 'FIS Value Load File',
    partner_name: 'FIS', file_type: 'value_load', direction: 'outbound',
    started_at: '2026-03-31T10:00:00Z', completed_at: '2026-03-31T10:00:15Z',
    total_rules: 3, passed: 2, failed: 0, warnings: 1, errors: 0, skipped: 0,
    overall_status: 'WARNING', executed_by: 'raajeshb@gmail.com',
  },
  {
    run_id: 'a1b2c3d4e5f60004', process_id: 3, process_name: 'KP Task Completion File',
    partner_name: 'Kaiser Permanente', file_type: 'task_completion', direction: 'inbound',
    started_at: '2026-03-31T11:00:00Z', completed_at: '2026-03-31T11:00:06Z',
    total_rules: 3, passed: 3, failed: 0, warnings: 0, errors: 0, skipped: 0,
    overall_status: 'PASSED', executed_by: 'raajeshb@gmail.com',
  },
  {
    run_id: 'a1b2c3d4e5f60005', process_id: 7, process_name: 'AB Corp Card Ship File',
    partner_name: 'AB Corp', file_type: 'card_ship', direction: 'inbound',
    started_at: '2026-03-31T14:00:00Z', completed_at: '2026-03-31T14:00:09Z',
    total_rules: 2, passed: 1, failed: 1, warnings: 0, errors: 0, skipped: 0,
    overall_status: 'FAILED', executed_by: 'raajeshb@gmail.com',
  },
  {
    run_id: 'a1b2c3d4e5f60006', process_id: 2, process_name: 'HAP Eligibility File',
    partner_name: 'HAP', file_type: 'eligibility', direction: 'inbound',
    started_at: '2026-03-30T08:00:00Z', completed_at: '2026-03-30T08:00:10Z',
    total_rules: 4, passed: 3, failed: 0, warnings: 1, errors: 0, skipped: 0,
    overall_status: 'WARNING', executed_by: 'raajeshb@gmail.com',
  },
];

export const mockExecutionDetails = {
  'a1b2c3d4e5f60001': [
    { rule_name: 'Row Count Match', rule_type: 'row_count', rule_code: 'row_count_match', ruleset_name: 'Eligibility Inbound Validation', status: 'pass', expected_value: '5,234', actual_value: '5,234', execution_ms: 1250, error_message: null },
    { rule_name: 'Required Fields Present', rule_type: 'field_validation', rule_code: 'required_fields_present', ruleset_name: 'Eligibility Inbound Validation', status: 'pass', expected_value: '0 nulls', actual_value: '0', execution_ms: 890, error_message: null },
    { rule_name: 'Duplicate Record Check', rule_type: 'field_validation', rule_code: 'duplicate_check', ruleset_name: 'Eligibility Inbound Validation', status: 'pass', expected_value: '0', actual_value: '0', execution_ms: 670, error_message: null },
    { rule_name: 'File Freshness Check', rule_type: 'completeness', rule_code: 'file_freshness_check', ruleset_name: 'Eligibility Inbound Validation', status: 'pass', expected_value: '< 48 hours', actual_value: '3 hours', execution_ms: 320, error_message: null },
  ],
  'a1b2c3d4e5f60002': [
    { rule_name: 'Row Count Match', rule_type: 'row_count', rule_code: 'row_count_match', ruleset_name: 'FIS Outbound Validation', status: 'pass', expected_value: '312', actual_value: '312', execution_ms: 980, error_message: null },
    { rule_name: 'Amount Balance Check', rule_type: 'balance_check', rule_code: 'amount_balance_check', ruleset_name: 'FIS Outbound Validation', status: 'fail', expected_value: '$156,000.00', actual_value: '$155,750.00', execution_ms: 1100, error_message: 'Balance mismatch: difference of $250.00. 2 records have zero amounts that may not have been included in the control total.' },
    { rule_name: 'Value Range Check', rule_type: 'field_validation', rule_code: 'value_range_check', ruleset_name: 'FIS Outbound Validation', status: 'pass', expected_value: '0', actual_value: '0', execution_ms: 540, error_message: null },
  ],
  'a1b2c3d4e5f60003': [
    { rule_name: 'Row Count Match', rule_type: 'row_count', rule_code: 'row_count_match', ruleset_name: 'FIS Outbound Validation', status: 'pass', expected_value: '1,045', actual_value: '1,045', execution_ms: 870, error_message: null },
    { rule_name: 'Amount Balance Check', rule_type: 'balance_check', rule_code: 'amount_balance_check', ruleset_name: 'FIS Outbound Validation', status: 'pass', expected_value: '$523,450.00', actual_value: '$523,450.00', execution_ms: 1050, error_message: null },
    { rule_name: 'Value Range Check', rule_type: 'field_validation', rule_code: 'value_range_check', ruleset_name: 'FIS Outbound Validation', status: 'warning', expected_value: '0', actual_value: '3', execution_ms: 620, error_message: '3 records with load_amount > $5,000. Values: $5,250, $7,100, $6,800. May require manual review.' },
  ],
  'a1b2c3d4e5f60004': [
    { rule_name: 'Row Count Match', rule_type: 'row_count', rule_code: 'row_count_match', ruleset_name: 'Task Completion Inbound Validation', status: 'pass', expected_value: '892', actual_value: '892', execution_ms: 760, error_message: null },
    { rule_name: 'Cross Reference Check', rule_type: 'cross_reference', rule_code: 'cross_reference_check', ruleset_name: 'Task Completion Inbound Validation', status: 'pass', expected_value: '0 orphans', actual_value: '0', execution_ms: 1430, error_message: null },
    { rule_name: 'Completeness Check', rule_type: 'completeness', rule_code: 'completeness_check', ruleset_name: 'Task Completion Inbound Validation', status: 'pass', expected_value: '0 missing', actual_value: '0', execution_ms: 1180, error_message: null },
  ],
  'a1b2c3d4e5f60005': [
    { rule_name: 'Completeness Check', rule_type: 'completeness', rule_code: 'completeness_check', ruleset_name: 'Card Ship Inbound Validation', status: 'fail', expected_value: '0 missing', actual_value: '23', execution_ms: 1560, error_message: '23 card orders from the last batch do not have corresponding shipping records. Order IDs available in details.' },
    { rule_name: 'File Freshness Check', rule_type: 'completeness', rule_code: 'file_freshness_check', ruleset_name: 'Card Ship Inbound Validation', status: 'pass', expected_value: '< 72 hours', actual_value: '18 hours', execution_ms: 290, error_message: null },
  ],
  'a1b2c3d4e5f60006': [
    { rule_name: 'Row Count Match', rule_type: 'row_count', rule_code: 'row_count_match', ruleset_name: 'Eligibility Inbound Validation', status: 'pass', expected_value: '3,102', actual_value: '3,102', execution_ms: 1100, error_message: null },
    { rule_name: 'Required Fields Present', rule_type: 'field_validation', rule_code: 'required_fields_present', ruleset_name: 'Eligibility Inbound Validation', status: 'pass', expected_value: '0 nulls', actual_value: '0', execution_ms: 780, error_message: null },
    { rule_name: 'Duplicate Record Check', rule_type: 'field_validation', rule_code: 'duplicate_check', ruleset_name: 'Eligibility Inbound Validation', status: 'warning', expected_value: '0', actual_value: '5', execution_ms: 590, error_message: '5 duplicate member_ids found. Members: M10234, M10567, M10891, M11023, M11456. These appear to be re-enrollments within the same file.' },
    { rule_name: 'File Freshness Check', rule_type: 'completeness', rule_code: 'file_freshness_check', ruleset_name: 'Eligibility Inbound Validation', status: 'pass', expected_value: '< 48 hours', actual_value: '6 hours', execution_ms: 310, error_message: null },
  ],
};
